import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs text-foreground-400 tracking-[0.2em] uppercase mb-3 font-label">Editor's Pick</p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            精选文章
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
            编辑团队为你挑选的慢时光佳作
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-100"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block text-xs text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full mb-3 font-medium whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">{article.author}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="whitespace-nowrap">{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="whitespace-nowrap">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}